import classNames from "classnames";
import { Route, Switch } from "react-router-dom";

import Project from "src/app/modules/user-projects/Details";
import Projects from "src/app/modules/user-projects/Table";
import { ROUTES } from "src/config/constants";

import userCSS from "./User.module.css";
import Profile from "./components/Profile";

function User() {
  return (
    <div className={classNames("u-bg-background", userCSS.container)}>
      <Switch>
        <Route path={ROUTES.userProjects} component={Projects} />
        <Route path={ROUTES.userProject} component={Project} />
        <Route path={ROUTES.userProfile} component={Profile} />
      </Switch>
    </div>
  );
}

export default User;
